var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0C12.5359 0 0 12.5359 0 28C0 43.4641 12.5359 56 28 56C43.4641 56 56 43.4641 56 28C56 12.5359 43.4641 0 28 0Z",
    fill: "#40B3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6244 16.1066L36.6231 41.3217C36.6231 41.3217 35.9238 43.0704 34.0003 42.231L22.4595 33.383L18.263 31.3548L11.1987 28.9765C11.1987 28.9765 10.1146 28.592 10.0096 27.7526C9.90457 26.9133 11.2337 26.4587 11.2337 26.4587L39.3159 15.4425C39.3159 15.4425 41.6242 14.4283 41.6242 16.107",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5727 41.0381C21.5727 41.0381 21.2358 41.0066 20.8158 39.6775C20.3965 38.3486 18.263 31.3543 18.263 31.3543L35.2244 20.583C35.2244 20.583 36.2038 19.9885 36.1688 20.583C36.1688 20.583 36.3436 20.688 35.8188 21.1776C35.2944 21.6674 22.4947 33.173 22.4947 33.173",
    fill: "#D2E5F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8846 36.7752L22.3199 40.9371C22.3199 40.9371 21.9629 41.2079 21.5727 41.0382L22.4468 33.3076",
    fill: "#B5CFE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.00de90721b27edc2e0d27f5321797569.svg";
export { ForwardRef as ReactComponent };